import {  formatNumber, formatToKM } from "Helpers/numbers";

export const formatCurrency = (val: unknown, currency?: string, options?: { isKM?: boolean }) =>
  `${currency}${options?.isKM ? formatToKM(Number(val)) : formatNumber(Number(val))}`;
